// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorTraffic } from './elevator-traffic';


export class ElevatorTrafficMessage implements flatbuffers.IUnpackableObject<ElevatorTrafficMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorTrafficMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorTrafficMessage):ElevatorTrafficMessage {
  return (obj || new ElevatorTrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorTrafficMessage):ElevatorTrafficMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorTrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorTraffic {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorTraffic.P;
}

position():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startElevatorTrafficMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorTraffic) {
  builder.addFieldInt16(0, message, ElevatorTraffic.P);
}

static addPosition(builder:flatbuffers.Builder, position:number) {
  builder.addFieldInt16(1, position, 0);
}

static endElevatorTrafficMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorTrafficMessage(builder:flatbuffers.Builder, message:ElevatorTraffic, position:number):flatbuffers.Offset {
  ElevatorTrafficMessage.startElevatorTrafficMessage(builder);
  ElevatorTrafficMessage.addMessage(builder, message);
  ElevatorTrafficMessage.addPosition(builder, position);
  return ElevatorTrafficMessage.endElevatorTrafficMessage(builder);
}

unpack(): ElevatorTrafficMessageT {
  return new ElevatorTrafficMessageT(
    this.message(),
    this.position()
  );
}


unpackTo(_o: ElevatorTrafficMessageT): void {
  _o.message = this.message();
  _o.position = this.position();
}



unpackFields(...fields: string[]): ElevatorTrafficMessageT {
  const t = new ElevatorTrafficMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  if (fieldSet.has('position')) {
    t.position = this.position();
  }
  return t;
}
}

export class ElevatorTrafficMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorTraffic = ElevatorTraffic.P,
  public position: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorTrafficMessage.createElevatorTrafficMessage(builder,
    this.message,
    this.position
  );
}

clone(): ElevatorTrafficMessageT {
  const obj = new ElevatorTrafficMessageT();
  obj.message = this.message;
  obj.position = this.position;
  return obj;
}

equals(other: ElevatorTrafficMessageT): boolean {
  if (this.message !== other.message) return false;
  if (this.position !== other.position) return false;
  return true;
}
}

export function verifyElevatorTrafficMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 2);
  } finally {
    verifier.popDepth();
  }
}
